"use strict";
/**
 * This file contains the enums for the different crypto chains and symbols.
 * Since they were originally created in the Rust code, they use the Rust
 * naming convention of PascalCase, and this must be followed here.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./argosWebhook"), exports);
__exportStar(require("./avenArgosService"), exports);
__exportStar(require("./coins"), exports);
__exportStar(require("./custodian"), exports);
__exportStar(require("./liability"), exports);
__exportStar(require("./machineDemo"), exports);
__exportStar(require("./deposit"), exports);
__exportStar(require("./monitoring"), exports);
__exportStar(require("./withdrawal"), exports);
__exportStar(require("./closure"), exports);
__exportStar(require("./liquidation"), exports);
__exportStar(require("./publicPolicy"), exports);
__exportStar(require("./updateLimit"), exports);
